import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import moduleA from "./modules/moduleA";
import moduleB from "./modules/moduleB";
import sys_common_store from "./modules/sys_common_store";
import approverStore from './modules/approverStore'
let store = new Vuex.Store({
  modules:{
    moduleA,
    moduleB,
    sys_common_store,
    approverStore,
  },
})
/*
{{$store.state.moduleB.str}} 根据命名空间访问state
{{$store.getters['moduleB/get_str']}} 根据命名空间访问getters
this.$store.commit('moduleB/set_str','mutation新值') 根据命名空间commit
this.$store.dispatch('moduleB/set_str','action新值') 根据命名空间dispatch

*/
export default store



// WEBPACK FOOTER //
// ./src/store/index.js